import React, {useEffect, useState} from "react";
import PropTypes, {InferProps} from "prop-types";
import {useFile, useInvoice, usePrincipal, useStripe} from "@betrue/front/services";
import {
  File,
  Invoice,
  InvoiceState,
  PaymentState,
  Scope,
  StripeAuthorize,
  SupplierInvoice
} from "@betrue/shared/interfaces";
import {AddInvoiceView} from "./add-invoice.view";
import {InvoiceModalForm} from "./invoice.form";

export const AddInvoicePropsTypes = {
  openModalLabel: PropTypes.string,
  dialogTitle: PropTypes.string,
  dialogDescription: PropTypes.string,
  amountUntaxedLabel: PropTypes.string,
  amountTotalLabel: PropTypes.string,
  referenceLabel: PropTypes.string,
  dropZoneLabel: PropTypes.string,
  dialogSubmit: PropTypes.string,
  dialogCancel: PropTypes.string,
  configurePaymentsLabel: PropTypes.string,
  configurePaymentsDescription: PropTypes.string

}

export type AddInvoiceProps = InferProps<typeof AddInvoicePropsTypes>

export const INVOICE_INITIAL_STATE: Invoice = {
  paymentLogs: [],
  file: undefined,
  removed: false,
  submitter: undefined,
  invoiceDate: new Date(),
  amountUntaxed: 0,
  amountTotal: 0,
  state: InvoiceState.DRAFT,
  reference: '',
  id: undefined,
  paymentState: PaymentState.NOT_PAID,
  version: undefined
}

export const AddInvoice = (props: AddInvoiceProps) => {
  const [principal] = usePrincipal()
  const [file, {uploadInvoiceFile, deleteFile}] = useFile<File>()
  const [createdInvoice, {createSupplierInvoice}] = useInvoice<Invoice>()
  const [invoices, {supplierInvoices}] = useInvoice<Invoice[]>()
  const [authorizeUrl, {authorize}] = useStripe<StripeAuthorize>()

  const [openModal, setOpenModal] = useState<boolean>(false)
  const [invoice, setInvoice] = useState<Invoice>(INVOICE_INITIAL_STATE)

  useEffect(() => {
    if (createdInvoice && principal) {
      supplierInvoices(principal.id)
    }
  }, [createdInvoice])

  useEffect(() => {
    if (principal && principal.scope === Scope.PARTNER && !principal.stripeAccountId) {
      authorize()
    }
  }, [principal])


  const openCloseModal = () => {
    setOpenModal(!openModal)
  }

  useEffect(() => {
    setInvoice({...invoice, file: file})

  }, [file])

  const handleSubmit = (form: InvoiceModalForm) => {
    createSupplierInvoice({
      submitter: {...principal}, ...form,
      file: file ? {...file} : undefined
    } as SupplierInvoice)
    setOpenModal(false)
  }

  useEffect(() => {
    if (!openModal) {
      setInvoice(INVOICE_INITIAL_STATE)
    }
  }, [openModal])

  const handleInvoiceDrop = (file) => {
    uploadInvoiceFile(file)
  }

  useEffect(() => {
    if (!openModal) {
      setInvoice(INVOICE_INITIAL_STATE)
    }
  }, [openModal])

  if (!invoice || !principal) return (<></>)

  return (
    <AddInvoiceView {...props} invoice={invoice}
                    enabled={(principal.scope === Scope.PARTNER)}
                    currentPerson={principal}
                    authorizeUrl={authorizeUrl?.authorizeUrl}
                    onSubmit={handleSubmit}
                    onFileDrop={handleInvoiceDrop}
                    onCloseModal={openCloseModal}
                    isOpen={openModal}
                    onOpenModal={openCloseModal}/>
  );
}


AddInvoice.propTypes = AddInvoicePropsTypes
